import AddressFormatter from 'features/shared/components/formatters/AddressFormatter';
import AddressDTO from 'features/shared/dtos/AddressDTO';
import AddressFindEnumDTO from 'features/shared/enums/dynamic/AddressFindEnumDTO';
import { Nullable } from 'features/shared/types/nullable';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './addressBox.module.scss';

interface Props {
  title: string;
  address: Nullable<AddressDTO | AddressFindEnumDTO>;
}

const AddressBox = ({ title, address }: Props) => {
  // translations
  const tLabels = useTranslation("requirements\\requirements").t;

  // sub-renders
  const renderAddress = () => {
    if (address) {
      return <AddressFormatter address={address as AddressDTO} />;
    } else {
      return <>{tLabels("addressBox.nullAddress")}</>
    }
  }

  // render
  return (
    <div className={styles.box}>
      <h6 className="text-muted mb-1">{title}</h6>
      {renderAddress()}
    </div>
  );
}

export default AddressBox;
